import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ContentProps } from './modalConfirmationDeliver.interface';
import * as S from './modalConfirmationDeliver.styles';

import { useAppSelector } from 'app/hooks';
import Button from 'blocks/Button';
import Row from 'blocks/Row';
import BaseModal from 'components/modals/BaseModal';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  productBookingState,
  productBookingmetaState,
  setProductBooking,
} from 'store/ProductBooking/productBookingSlice';
import ajax from 'utils/ajax';
import urls from 'utils/urls';
const Content = ({ closeModal, id, index }: ContentProps) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const booking = useAppSelector(productBookingState);
  const meta = useAppSelector(productBookingmetaState);
  if (!id) return null;

  const changeStatus = async () => {
    const res = await ajax({
      url: urls.cancelProduct,
      method: 'PATCH',
      data: { productBookingId: id },
    }).finally(() => closeModal());
    if (!res) return;
    const copyBooking = [...booking];
    copyBooking.splice(index, 1, res.productBooking);

    dispatch(
      setProductBooking({
        productBooking: copyBooking,
        pageMeta: meta,
      })
    );
  };

  return (
    <S.DeliverDetailModal>
      <S.Wrapper>
        <S.ParentSvg>
          <InfoOutlinedIcon color="info" fontSize="inherit" />
        </S.ParentSvg>
        <S.Title> {t('pages.services.Products.sections.Booking.sections.cancelPurchase.modals.fields.label')}</S.Title>

        <S.Description>
          {' '}
          {t('pages.services.Products.sections.Booking.sections.cancelPurchase.modals.fields.desc')}
        </S.Description>

        <Row align="center" justify="space-around">
          <Button width={80} onClick={closeModal}>
            {t('pages.services.Products.sections.Booking.sections.cancelPurchase.modals.fields.BtnNo')}
          </Button>
          <Button color="danger" width={80} onClick={() => changeStatus()}>
            {t('pages.services.Products.sections.Booking.sections.cancelPurchase.modals.fields.BtnYse')}
          </Button>
        </Row>
      </S.Wrapper>
    </S.DeliverDetailModal>
  );
};

interface State {
  open: boolean;
  id: null;
  index: null;
}

interface Props {
  ref: any;
}

class CanclePurchas extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      id: null,
      index: null,
    };
  }

  openModal = (id: any, index: any): void => this.setState({ open: true, id, index });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.DeliverDetailModalContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        {this.state.id ? (
          <Content
            {...this.props}
            open={this.state.open}
            closeModal={this.closeModal}
            id={this.state.id}
            index={this.state.index}
          />
        ) : null}
      </S.DeliverDetailModalContainer>
    );
  }
}

export default CanclePurchas;
